export default "__VITE_ASSET__BywSTxAH__"